module.exports = __webpack_public_path__ + "media/images/emblems/Marsens-coat_of_arms-95128c3efb4b4d4cf7028e9b4b211786.svg";